import { Tooltip } from 'antd'
import classNames from 'classnames'
import { FC, ReactNode } from 'react'
import { Colors, IconNames } from '../../util/types'
import { icons } from './icons'
import './index.less'

interface PerIconProps {
  name: IconNames
  color?: Colors
  size?: number
  variant?: 'decoration' | 'clickable'
  className?: string
  tooltip?: string | ReactNode
  spin?: boolean
  testId?: string
}

const PerIcon: FC<PerIconProps> = ({ name, color, variant, size = 24, className, tooltip, spin = false, testId }) => {
  // the app breaks sometimes have the name determined upon a server request
  if (!name) {
    return <></>
  }
  const { d, width: iconVbW = 24, height: iconVbH = 24 } = icons[name]

  const prefix = 'per-icon'
  const modifiers: string[] = []

  let viewBoxX = 0
  let viewBoxY = 0
  let viewBoxWidth = iconVbW
  let viewBoxHeight = iconVbH
  let getStrokeWidth = 0

  const nameHasStroke = name.includes('_stroke')
  if (nameHasStroke) {
    if (variant === 'decoration') {
      getStrokeWidth = 1
    } else if (variant === 'clickable') {
      getStrokeWidth = 2
    } else {
      getStrokeWidth = 2
    }
    viewBoxX = viewBoxX - getStrokeWidth / 2
    viewBoxY = viewBoxY - getStrokeWidth / 2
    viewBoxWidth = viewBoxWidth + getStrokeWidth
    viewBoxHeight = viewBoxHeight + getStrokeWidth
    modifiers.push(`${prefix}--stroke`)
  }
  if (color) {
    modifiers.push(`${prefix}--${color}`)
  }
  if (className) {
    modifiers.push(className)
  }
  if (spin) {
    modifiers.push(`${prefix}--spin`)
  }

  const renderSvg = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size + 'px'}
      height={size + 'px'}
      strokeWidth={getStrokeWidth + 'px'}
      className={classNames('per-icon', modifiers.join(' '))}
      viewBox={`${viewBoxX} ${viewBoxY} ${viewBoxWidth} ${viewBoxHeight}`}
      data-testid={`per-icon-id-${name}`}
      id={testId} // needed for cypress component testing
    >
      {d && <path vectorEffect="non-scaling-stroke" d={d} />}
    </svg>
  )

  return <>{tooltip ? <Tooltip title={tooltip}>{renderSvg()}</Tooltip> : renderSvg()}</>
}

export default PerIcon
